import { text } from '@modules/login/text';
import { useAuthActions } from '@convex-dev/auth/react';
import { getLoginErrorMessage } from '@modules/login/business_logic';
import { useLoginStore } from '@shared/store/useLoginStore';

export function useLoginSubmit(
  onSuccess: (message: string) => void,
  onError: (message: string) => void,
  onSuccessNavigate: () => void
) {
  const { signIn } = useAuthActions();
  const form = useLoginStore((s) => s.form);
  const setIsSubmitting = useLoginStore((s) => s.setIsSubmitting);
  const reset = useLoginStore((s) => s.reset);

  return () => {
    if (!form.email || !form.password) return;

    setIsSubmitting(true);

    const formData = new FormData();
    formData.append('email', form.email);
    formData.append('password', form.password);
    formData.append('flow', 'signIn');

    signIn('password', formData)
      .then(() => {
        onSuccess(text.success);
        reset();
        onSuccessNavigate();
      })
      .catch((error: Error) => {
        onError(getLoginErrorMessage(error));
        setIsSubmitting(false);
      });
  };
}
